package de.oevbs.kunde.kundenportal2.model.services.contact.types

import kotlinx.serialization.Serializable

@Serializable
enum class ContactMessageType(val text: String = "", val key: Int = -1) {
    CONSULTANT_MESSAGE("Berater kontaktieren", 1),
    CONTRACT_INFORMATION("Mitteilung zum Vertrag", 2),
    LOSS_INFORMATION("Mitteilung zum Schaden", 3),
    GENERAL_INFORMATION("Feedback zu Meine Öffentliche", 4),
    COMPLAINT_MESSAGE("Ihre Beschwerde", 5),
}
